import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "root-index" };
import Gnb from '@/views/Gnb.vue';
import OrderWrapper from '@/views/MapControl/OrderWrapper/index.vue';
import WorkerWrapper from '@/views/MapControl/WorkerWrapper/index.vue';
import MapWrapper from '@/views/MapControl/MapWrapper.vue';
import AllocationController from '@/components/AllocationController.vue';
// import ModalWorkerInfo from '@/views/MapControl/Dialog/ModalWorkerInfo.vue';
import DialogOrderInfo from '@/components/Common/DialogOrderInfo.vue';
import DialogMapConfig from '@/views/MapControl/Dialog/DialogMapConfig.vue';
import OrderStateButtonWrapper from '@/views/MapControl/Header/OrderStateButtonWrapper.vue';
import AllocationAlert from '@/components/AllocationAlert.vue';
import { computed, ref, watchEffect, } from 'vue';
import eventBus from '@/eventBus';
import eventBusEvent from '@/constants/eventBusEvent';
import vuexStore from '@/vuex-store';
import { allocationControllerActionType } from '@/vuex-store/allocation-controller/actions';
import { useRoute } from 'vue-router';
import hubStorage from '@/helpers/hubStorage';
import { mapControlActionType } from '@/vuex-store/map-control/actions';
import ModalWorkerInfo2 from '@/views/MapControl/Dialog/ModalWorkerInfo2.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const route = useRoute();
        const { fullpage: isFullPage, isHQ, } = route.query;
        const isOrderListDrawerOpen = ref(!isFullPage);
        const isWorkerListDrawerOpen = ref(!isFullPage);
        const rootMapWrapperClass = computed(() => ({
            'root-map-wrapper': true,
            'order-wrapper__hide': !isOrderListDrawerOpen.value,
            'worker-wrapper__hide': !isWorkerListDrawerOpen.value,
            'map-object': true,
        }));
        const rootOrderWrapperClass = computed(() => ({
            'root-wrapper': true,
            'order-wrapper-body': true,
            hide: !isOrderListDrawerOpen.value,
        }));
        const rootWorkerWrapperClass = computed(() => ({
            'root-wrapper': true,
            'worker-wrapper-body': true,
            hide: !isWorkerListDrawerOpen.value,
        }));
        // created() {
        // },
        // methods: {
        /**
         * 토큰 로그인 유저의 경우 새로고침이 아니면 로그인 페이지로 이탈 시킨다.
         */
        const checkTokenLoginUser = () => {
            const isQueryTokenLoginUser = hubStorage.getItem('queryTokenLoginUser');
            const isReloaded = hubStorage.getSessionItem('reloaded') === '1';
            // 쿼리 토큰 로그인 유저의 단순 새로고침시에 토큰 제거 x
            if (isQueryTokenLoginUser && isReloaded) {
                return;
            }
            if (isQueryTokenLoginUser) {
                hubStorage.removeItem('queryTokenLoginUser');
                hubStorage.removeSessionItem('reloaded');
                vuexStore.dispatch('user/logout');
                return;
            }
            // Line 209에 의해 타 세션(B)에서 HCR 접근시 강제 로그아웃으로 reloaded가 제거되나, 현재 세션(A)은 reloaded가 남아있음.
            hubStorage.removeSessionItem('reloaded');
        };
        vuexStore.dispatch(mapControlActionType.setIsHQ, isHQ);
        vuexStore.dispatch(allocationControllerActionType.setOnCloseAction, () => {
            eventBus.emit(eventBusEvent.MapWrapper_actionEsc);
        });
        checkTokenLoginUser();
        watchEffect(() => {
            const value = vuexStore.state.mapControl.selectedWorker;
            vuexStore.dispatch(allocationControllerActionType.setWorker, value);
        });
        watchEffect(() => {
            const value = vuexStore.state.mapControl.selectedOrderItemsObj;
            vuexStore.dispatch(allocationControllerActionType.setOrderList, value);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createCommentVNode(" header "),
                _createVNode(Gnb, null, {
                    default: _withCtx(() => [
                        _createCommentVNode(" 주문 상태 버튼 "),
                        _createVNode(OrderStateButtonWrapper)
                    ]),
                    _: 1 /* STABLE */
                }),
                _createCommentVNode(" 배달 목록 "),
                _createVNode(OrderWrapper, {
                    class: _normalizeClass(rootOrderWrapperClass.value),
                    "is-drawer-open": isOrderListDrawerOpen.value,
                    "onUpdate:isDrawerOpen": _cache[0] || (_cache[0] = ($event) => ((isOrderListDrawerOpen).value = $event))
                }, null, 8 /* PROPS */, ["class", "is-drawer-open"]),
                _createCommentVNode(" 라이더 목록 "),
                _createVNode(WorkerWrapper, {
                    class: _normalizeClass(rootWorkerWrapperClass.value),
                    "is-drawer-open": isWorkerListDrawerOpen.value,
                    "onUpdate:isDrawerOpen": _cache[1] || (_cache[1] = ($event) => ((isWorkerListDrawerOpen).value = $event))
                }, null, 8 /* PROPS */, ["class", "is-drawer-open"]),
                _createCommentVNode(" 지도 "),
                _createVNode(MapWrapper, {
                    ref: "mapWrapper",
                    class: _normalizeClass(rootMapWrapperClass.value)
                }, null, 8 /* PROPS */, ["class"]),
                _createCommentVNode(" [다이얼로그] 배차 컨트롤러 (배차, 재배차 등 기능) "),
                _createVNode(AllocationController),
                _createCommentVNode(" [다이얼로그] 라이더 상세 v2 "),
                _createVNode(ModalWorkerInfo2),
                _createCommentVNode(" [다이얼로그] 주문 상세 "),
                _createVNode(DialogOrderInfo),
                _createCommentVNode(" [다이얼로그] 지도관제 설정 "),
                _createVNode(DialogMapConfig),
                _createCommentVNode(" 배차 결과 "),
                _createVNode(AllocationAlert)
            ]));
        };
    }
});
